import React, { useState, useEffect } from 'react';

export default function KhipuNotify() {
  const [ApiVersion, setApiVersion] = useState("");
  const [NotificationToken, setNotificationToken] = useState("");
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setApiVersion(params.get('api_version'));
    setNotificationToken(params.get('notification_token'));
  }, []);

  return (
    <div>
      <h1>API Version</h1>
      <h2>{ApiVersion}</h2>
      <br />
      <br />
      <h1>Notification Token</h1>
      <h2>{NotificationToken}</h2>
    </div>
  )
}
